(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(scope = document) {
    const items = [...scope.querySelectorAll('.mm-reveal:not([data-mm-bound])')];
    if (!items.length) return;
    items.forEach((el) => {
      el.dataset.mmBound = 'true';
      const delay = parseInt(el.dataset.mmDelay || '0', 10);
      if (delay) el.style.transitionDelay = `${delay}ms`;
    });
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.13, rootMargin: '0px 0px -6% 0px' });
    items.forEach((el) => io.observe(el));
  }

  function initMethodFinder(scope = document) {
    scope.querySelectorAll('[data-mm-method-finder]:not([data-mm-ready])').forEach((finder) => {
      finder.dataset.mmReady = 'true';
      const tabs = [...finder.querySelectorAll('[data-mm-method-tab]')];
      const panels = [...finder.querySelectorAll('[data-mm-method-panel]')];
      const activate = (index) => {
        tabs.forEach((tab, i) => {
          const active = i === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel, i) => {
          const active = i === index;
          if (active) panel.hidden = false;
          panel.classList.toggle('is-active', active);
          if (!active) {
            window.setTimeout(() => {
              if (!panel.classList.contains('is-active')) panel.hidden = true;
            }, reduce ? 0 : 430);
          }
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', (e) => {
          if (!['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft'].includes(e.key)) return;
          e.preventDefault();
          const next = (index + (['ArrowDown','ArrowRight'].includes(e.key) ? 1 : -1) + tabs.length) % tabs.length;
          tabs[next].focus();
          activate(next);
        });
      });
    });
  }

  function initHeroParallax(scope = document) {
    if (reduce || window.matchMedia('(max-width: 989px)').matches) return;
    scope.querySelectorAll('.mm-hero__visual:not([data-mm-parallax])').forEach((visual) => {
      visual.dataset.mmParallax = 'true';
      const image = visual.querySelector('.mm-hero__image');
      if (!image) return;
      let frame = null;
      const onMove = (e) => {
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const r = visual.getBoundingClientRect();
          const x = ((e.clientX - r.left) / r.width - 0.5) * 8;
          const y = ((e.clientY - r.top) / r.height - 0.5) * 6;
          image.style.transform = `translate3d(${x}px, ${y}px, 0)`;
        });
      };
      visual.addEventListener('pointermove', onMove);
      visual.addEventListener('pointerleave', () => { image.style.transform = ''; });
    });
  }

  function init(scope = document) {
    initReveal(scope);
    initMethodFinder(scope);
    initHeroParallax(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
